export default __webpack_public_path__ + "static/media/suite-case.6bba830b.svg";